import { Container, Stack, Dropdown, Button } from "react-bootstrap";

function Scope({ setRegional, toggleNational }) {
  return (
    <Container className="Scope">
      <Stack direction="horizontal" gap={3}>
        <Button
          className="Scope_button"
          variant="dark"
          active
          onClick={() => {
            toggleNational(true);
          }}
        >
          National
        </Button>
        <Dropdown>
          <Dropdown.Toggle
            className="Scope_button"
            variant="light"
            id="dropdown-basic"
          >
            Regional
          </Dropdown.Toggle>
          <Dropdown.Menu className="Regional_Dropdown">
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("north");
              }}
            >
              North
            </Dropdown.Item>
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("north east");
              }}
            >
              North East
            </Dropdown.Item>
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("east");
              }}
            >
              East
            </Dropdown.Item>
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("south");
              }}
            >
              South
            </Dropdown.Item>
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("west");
              }}
            >
              West
            </Dropdown.Item>
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("central");
              }}
            >
              Central
            </Dropdown.Item>
            <Dropdown.Item
              className="Regional_Dropdown_Menu"
              onClick={() => {
                toggleNational(false);
                setRegional("islands");
              }}
            >
              Islands
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Stack>
    </Container>
  );
}

export default Scope;
